import nest from './nest';
import { logNavegacao } from '../function';

/**
 * Avaliação da coleta pelo cliente (1 a 5 estrelas).
 *
 * Contrato: Greenium2023-Back/src/clientes/coletas-avaliacoes/coletas-avaliacoes.controller.ts
 *   GET  /cliente/coletas/avaliacoes?ordens=101,102
 *   POST /cliente/coletas/:ordemId/avaliacao
 *
 * A listagem de coletas vem do PHP, mas a avaliação é do Nest — que é onde o
 * portal já autentica, então o mesmo token serve.
 *
 * Falha aqui NÃO é silenciosa: o erro é registrado em `cliente_app_log` (com o
 * cliente identificado pelo token) e propagado, para a tela avisar. Engolir a
 * falha faria o botão "Avaliar" sumir sem ninguém descobrir por quê.
 */

/**
 * O interceptor do axios deste projeto RESOLVE a promise com um Error quando a
 * rede falha (`if (error.response === undefined) return error`) em vez de
 * rejeitar. Sem esta checagem, a tela receberia lixo achando que deu certo.
 */
function garantirResposta(resposta) {
  if (resposta instanceof Error) throw resposta;
  if (!resposta || resposta.data === undefined) {
    throw new Error('Resposta inesperada do servidor');
  }
  return resposta.data;
}

/** Detalhe curto e útil para o log: status HTTP quando há, mensagem quando não. */
function detalheDoErro(erro) {
  if (erro?.response?.status) {
    const corpo = erro.response.data?.message;
    return `HTTP ${erro.response.status}${corpo ? ` - ${corpo}` : ''}`;
  }
  return erro?.message || 'falha desconhecida';
}

/** Registra no mesmo canal que o resto do portal usa (`POST /clients/log`). */
function registrar(acao, erro) {
  // Truncado: `cliente_app_log.action` guarda uma ação, não um stack trace.
  logNavegacao('erro', `${acao}: ${detalheDoErro(erro)}`.slice(0, 180));
}

/** Estado de avaliação das coletas informadas. */
export async function buscarAvaliacoes(ordemIds) {
  if (!ordemIds || ordemIds.length === 0) return [];

  try {
    const resposta = await nest.get('/cliente/coletas/avaliacoes', {
      params: { ordens: ordemIds.join(',') },
    });
    return garantirResposta(resposta) ?? [];
  } catch (erro) {
    registrar('avaliacoes/listar', erro);
    throw erro;
  }
}

/** Envia a nota. O erro sobe para a tela mostrar a mensagem do backend. */
export async function enviarAvaliacao(ordemId, { nota, comentario }) {
  try {
    const resposta = await nest.post(`/cliente/coletas/${ordemId}/avaliacao`, {
      nota,
      comentario,
    });
    return garantirResposta(resposta);
  } catch (erro) {
    registrar(`avaliacoes/enviar/${ordemId}`, erro);
    throw erro;
  }
}
